/* APG main LP only. No shared theme dependencies or client-side API secrets. */
(function () {
  'use strict';
  const root = document.getElementById('lp-main-page');
  if (!root) return;
  const form = root.querySelector('#lp-main-form');
  const status = root.querySelector('#lp-form-status');
  const button = form.querySelector('button[type=submit]');
  const originalLabel = button.innerHTML;
  let busy = false, accepted = false, counted = false, receipt = null, googleLoaded = false;
  const tiers = {
    '10,000-20,000': 'ovKPCICWkeAYEIqVu9wC',
    '20,000-30,000': 'XwIZCOKDm-AYEIqVu9wC',
    '30,000-40,000': 'iJgFCMydkeAYEIqVu9wC',
    '40,000-50,000': 'DLh0CPWfkeAYEIqVu9wC',
    '50,000+': '7LHyCN3dleAYEIqVu9wC'
  };
  function allowed() {
    return !!(window.Shopify && window.Shopify.customerPrivacy && window.Shopify.customerPrivacy.marketingAllowed());
  }
  function tag() { (window.dataLayer = window.dataLayer || []).push(arguments); }
  function consentChanged() {
    if (!allowed()) {
      if (googleLoaded) tag('consent','update',{ad_storage:'denied',ad_user_data:'denied',ad_personalization:'denied',analytics_storage:'denied'});
      return;
    }
    if (!googleLoaded) {
      googleLoaded = true;
      tag('consent','default',{ad_storage:'denied',ad_user_data:'denied',ad_personalization:'denied',analytics_storage:'denied'});
      tag('js',new Date());
      tag('consent','update',{ad_storage:'granted',ad_user_data:'granted',ad_personalization:'granted',analytics_storage:'denied'});
      tag('config','AW-730778250');
      const script = document.createElement('script'); script.async = true;
      script.src = 'https://www.googletagmanager.com/gtag/js?id=AW-730778250'; document.head.appendChild(script);
    } else tag('consent','update',{ad_storage:'granted',ad_user_data:'granted',ad_personalization:'granted'});
    if (!receipt || counted) return;
    counted = true;
    tag('event','conversion',{send_to:'AW-730778250/sSNQCLb8upQDEIqVu9wC',transaction_id:receipt.id});
    if (tiers[receipt.quantity]) tag('event','conversion',{send_to:'AW-730778250/'+tiers[receipt.quantity],transaction_id:receipt.id});
    window.dataLayer.push({event:'apg_lp_inquiry_success',landing_page:'main',submission_id:receipt.id});
  }
  document.addEventListener('visitorConsentCollected',consentChanged);
  if (window.Shopify && window.Shopify.loadFeatures) window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}],function(error){if(!error)consentChanged();});
  root.querySelectorAll('[data-lp-message]').forEach(function(link){link.addEventListener('click',function(event){
    event.preventDefault();
    const field=form.elements.message, prompt=link.dataset.lpMessage;
    if(link.dataset.lpInterest)form.elements.interests.value=link.dataset.lpInterest;
    if(link.dataset.lpLooking)form.elements.looking_for.value=link.dataset.lpLooking;
    // Preserve anything already written; repeated clicks must not duplicate the prompt.
    if(!field.value.includes(prompt.trim()))field.value+=(field.value.trim()?'\n':'')+prompt;
    field.focus({preventScroll:true});field.setSelectionRange(field.value.length,field.value.length);
    field.scrollIntoView({behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'center'});
  });});
  // Give every general inquiry CTA a visible destination, including at the top.
  let invitationAnimation = null, invitationTimer = null;
  root.querySelectorAll('a[href="#main-inquiry"]:not([data-lp-message])').forEach(function(link){
    link.addEventListener('click',function(event){
      event.preventDefault();
      const shell = root.querySelector('#main-inquiry');
      const heading = shell.querySelector('.lp-form-title');
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const alreadyVisible = shell.getBoundingClientRect().top >= 80 && shell.getBoundingClientRect().top < window.innerHeight / 2;
      if(invitationAnimation)invitationAnimation.cancel();
      window.clearTimeout(invitationTimer);
      heading.setAttribute('tabindex','-1');
      heading.focus({preventScroll:true});
      shell.scrollIntoView({behavior:reduced?'auto':'smooth',block:'start'});
      invitationTimer = window.setTimeout(function(){
        const resting = window.getComputedStyle(shell).boxShadow;
        const glow = '0 0 0 4px rgba(0,163,231,.23), 0 24px 60px -24px rgba(0,121,195,.3)';
        const frames = reduced ? [{boxShadow:resting},{boxShadow:glow},{boxShadow:resting}] : [
          {transform:'translateY(0)',boxShadow:resting},
          {transform:'translateY(-5px)',boxShadow:glow,offset:.35},
          {transform:'translateY(2px)',boxShadow:glow,offset:.65},
          {transform:'translateY(0)',boxShadow:resting}
        ];
        invitationAnimation = shell.animate(frames,{duration:1100,easing:'ease-in-out'});
      },alreadyVisible || reduced ? 0 : 450);
    });
  });
  function message(text,error){status.textContent=text;status.dataset.error=String(!!error);status.focus();}
  window.addEventListener('submit',async function(event){
    if(event.target!==form)return;
    event.preventDefault();event.stopImmediatePropagation();
    if(busy||accepted)return;
    if(!form.reportValidity())return;
    if(!window.grecaptcha||!window.grecaptcha.getResponse()){message('Please complete the reCAPTCHA before sending your inquiry.',true);return;}
    busy=true;button.disabled=true;button.textContent='Sending your inquiry…';status.textContent='';
    const data=new FormData(form);
    const id=window.crypto.randomUUID ? window.crypto.randomUUID() : 'lp-'+Date.now()+'-'+Math.random().toString(36).slice(2);
    data.set('apg_submission_id',id);data.set('inquiry_page',window.location.origin+window.location.pathname);
    if(allowed()){
      const params=new URLSearchParams(window.location.search);
      ['utm_source','utm_medium','utm_campaign','utm_term','utm_content','gclid','gbraid','wbraid','msclkid'].forEach(function(key){if(params.has(key))data.set(key,params.get(key).slice(0,500));});
    }
    try{
      const response=await fetch(form.action,{method:'POST',body:data,headers:{Accept:'application/json'}});
      if(!response.ok)throw new Error('Not accepted');
      const result=await response.json();
      if(!result||result.success!==true)throw new Error('No confirmed receipt');
      accepted=true;receipt={id:id,quantity:data.get('est_order_qty')};button.textContent='Inquiry received ✓';
      message('Thank you. APG has received your inquiry. Our team will follow up about your project.',false);
      try{consentChanged();}catch(error){/* A received inquiry stays successful even if tracking is unavailable. */}
    }catch(error){busy=false;button.disabled=false;button.innerHTML=originalLabel;message('We could not confirm your inquiry. Your details are still here. Please try again.',true);if(window.grecaptcha)window.grecaptcha.reset();}
  },true);
}());
